import http from './../http.interceptor.js';
export function activities(params) {
	return http.get('/v3.home/activities', {
		isLOgin:true,
		...params
	})
}